import React from 'react'
import { localizedText } from '../../utils/localized';
import { getCatalogLabel, getPriorityAppearance, getPriorityLabel } from '../../constants/ticket.js'

const TicketsListItem = ({ item, lang, gridTemplate, supportSettings }) => {
    const createDate = (() => {
        const date = item?.createdAt ? new Date(item.createdAt) : null;
        if (!date || Number.isNaN(date.getTime())) return '-';
        return date.toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
    })();
    const updatedDate = (() => {
        const raw = item?.modifiedAt || item?.updatedAt || null;
        const date = raw ? new Date(raw) : null;
        if (!date || Number.isNaN(date.getTime())) return '-';
        return date.toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
    })();
    const _section = getCatalogLabel(supportSettings?.sections, item.sectionId, lang);
    const _product = getCatalogLabel(supportSettings?.products, item.ProductId, lang);
    const priorityMeta = getPriorityAppearance(item?.priority || 'medium');
    const subjectTextAlign = lang === 'ar' ? 'right' : 'left';
    return (
        <div
            style={{
                display: 'grid',
                gridTemplateColumns: gridTemplate,
                gap: 8,
                alignItems: 'center',
                padding: '14px 16px',
                fontSize: 12,
                color: '#475569',
                background: '#fff',
                borderBottom: '1px solid #e2e8f0',
                transition: 'all .15s'
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.background = '#f8fafc';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.background = '#fff';
            }}
        >
            <div style={{ textAlign: 'center', fontWeight: 700, color: '#0f172a' }}>{item.ticketNumber || '-'}</div>
            <div style={{ fontWeight: 700, color: '#0f172a', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: subjectTextAlign }} dir="auto">{localizedText(item, 'subject', lang)}</div>
            <div style={{ textAlign: 'center', whiteSpace: 'normal', lineHeight: 1.35, wordBreak: 'break-word' }}>
                <div style={{ fontWeight: 500, color: '#0f172a' }}>{_section}</div>
                <div style={{ marginTop: 2, fontSize: 11, fontWeight: 400, color: '#64748b' }}>{_product}</div>
            </div>
            <div style={{ textAlign: 'center' }}>
                <span style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '5px 10px',
                    borderRadius: 999,
                    background: priorityMeta.bg,
                    color: priorityMeta.color,
                    fontWeight: 800,
                    whiteSpace: 'nowrap'
                }}>
                    {getPriorityLabel(item?.priority || 'medium', lang)}
                </span>
            </div>
            <div style={{ textAlign: 'center', lineHeight: 1.35 }}>
                <div style={{ fontWeight: 500, color: '#0f172a' }}>{createDate}</div>
                <div style={{ marginTop: 2, fontSize: 11, fontWeight: 400, color: '#64748b' }}>{updatedDate}</div>
            </div>
        </div>
    )
}

export default TicketsListItem
